import { TeamBadge } from "@/components/TeamBadge";
import { useI18n } from "@/context/I18nContext";

export function StandingsTable({ table, title, compareTo }) {
  const { t } = useI18n();
  const compareMap = compareTo
    ? Object.fromEntries(compareTo.map((r) => [r.team_id, r.position]))
    : null;

  return (
    <div className="bg-card border-2 border-foreground" data-testid="standings-table">
      {title && (
        <div className="px-5 py-3 border-b-2 border-foreground bg-foreground text-background">
          <p className="overline">{title}</p>
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="text-muted-foreground text-[10px] uppercase tracking-[0.15em] font-data border-b-2 border-border">
              <th className="text-start font-bold py-2.5 ps-5 w-10">#</th>
              <th className="text-start font-bold py-2.5">{t("table.team")}</th>
              <th className="text-center font-bold py-2.5 w-10">P</th>
              <th className="text-center font-bold py-2.5 w-10 hidden sm:table-cell">W</th>
              <th className="text-center font-bold py-2.5 w-10 hidden sm:table-cell">D</th>
              <th className="text-center font-bold py-2.5 w-10 hidden sm:table-cell">L</th>
              <th className="text-center font-bold py-2.5 w-12">GD</th>
              <th className="text-center font-bold py-2.5 pe-5 w-12">Pts</th>
            </tr>
          </thead>
          <tbody className="font-data">
            {table.map((r) => {
              const prev = compareMap ? compareMap[r.team_id] : null;
              const delta = prev != null ? prev - r.position : null;
              return (
                <tr key={r.team_id} className="border-b border-border even:bg-white/[0.03] hover:bg-primary/10 transition-colors" data-testid={`standings-row-${r.short}`}>
                  <td className="py-2.5 ps-5 font-bold text-base text-muted-foreground">{String(r.position).padStart(2, "0")}</td>
                  <td className="py-2.5">
                    <div className="flex items-center gap-3">
                      <TeamBadge team={r} size={26} />
                      <span className="font-semibold font-['IBM_Plex_Sans']">{r.name}</span>
                      {delta != null && delta !== 0 && (
                        <span className={`text-xs font-bold ${delta > 0 ? "text-[hsl(var(--pitch-green))]" : "text-destructive"}`}>
                          {delta > 0 ? `▲${delta}` : `▼${-delta}`}
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="text-center py-2.5">{r.played}</td>
                  <td className="text-center py-2.5 hidden sm:table-cell">{r.won}</td>
                  <td className="text-center py-2.5 hidden sm:table-cell">{r.drawn}</td>
                  <td className="text-center py-2.5 hidden sm:table-cell">{r.lost}</td>
                  <td className="text-center py-2.5">{r.gd > 0 ? `+${r.gd}` : r.gd}</td>
                  <td className="text-center py-2.5 pe-5 font-bold text-base text-primary">{r.points}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
